import ReactDOM  from "react-dom";
import Router from './router';
import {Provider} from 'react-redux'
import store from './store'
import "./assets/css/input.css"
import "./assets/css/base.less"
import "./assets/css/flash.css"
import Loading from './components/loading/Loading';



import './locales/i18n';


ReactDOM.render(
    <Provider store={store}>
       
        <Loading/>
       
            <Router/>
       
        
        
    </Provider>
    ,
    document.getElementById("root")
)